import Modal from './basicModal'
import React, { useState } from 'react'


export const useModal = () => {
  const [isVisible, setIsVisible] = useState(false)
   
   
  const show = (id) => setIsVisible(true)
  const hide = (id) => setIsVisible(false)
   
  const RenderModal = ({ children }) => (
    <React.Fragment >
      {isVisible && <Modal destroyOnClose={true}  >{children}</Modal>}
    </React.Fragment>
  )
   
   
  return {
    show,
    hide,
    RenderModal,
  }
}

// export const useModaltwo = ()=>{
//   const [isVisible, setIsVisible] = useState(false)
//   console.log(123)
//   const showadd = () => setIsVisible(true)
//   const hideadd = () => setIsVisible(false)

//   const RenderModal2 = ({ children }) => (
//     <React.Fragment >
//       {isVisible && <Modal destroyOnClose={true}  closeModal={hideadd}>{children}</Modal>}
//     </React.Fragment>
//   )
   
   
//   return {
//     showadd,
//     hideadd,
//     RenderModal2,
//   }
// }
 